<div class="flex h-screen overflow-hidden">
  <main class="flex-1 p-4 overflow-y-auto">

<app-buttons type="primary" text="Primary Button" size="medium" [disabled]="true"></app-buttons>
<app-buttons type="primary-border" text="Border Button" size="medium"></app-buttons>
<app-buttons type="primary-borderless" text="Borderless Button" size="medium"></app-buttons>
<app-buttons type="primary" text="With Icon" icon="fi fi-rs-user" size="medium"></app-buttons>
<app-buttons type="loader" text="Loading..." [loading]="true" size="medium"></app-buttons>

    <div class="flex gap-6">
        <app-buttons [id]="'btn-cancel'" (buttonClick)="showModalTest()"  [type]="'primary'" 
               [text]="'Omitir'" [fullWidth]="false" 
               [additionalClasses]="'h-12 md:h-14 w-auto px-6'">
  </app-buttons>
        <app-buttons [id]="'btn-cancel'" (buttonClick)="showModal2()" [type]="'primary'" 
               [text]="'Omitir'" [fullWidth]="false" 
               [additionalClasses]="'h-12 md:h-14 w-auto px-6'">
  </app-buttons>
        <app-buttons [id]="'btn-cancel'" (buttonClick)="showModal3()" [type]="'primary'" 
               [text]="'Omitir'" [fullWidth]="false" 
               [additionalClasses]="'h-12 md:h-14 w-auto px-6'">
  </app-buttons>

      <app-buttons type="primary-border" text="button" (buttonClick)="showToast()" [icon]="'fi fi-rr-button'" size="medium" id="btn-button"/>
      <app-dropdown-simple></app-dropdown-simple>

    </div>
<app-buttons type="secundary-inverted" text="Modal Dinamico" size="medium"  (buttonClick)="showModal4()"></app-buttons>
<app-buttons type="primary" text="Vista Previa en Modal" size="medium"  (buttonClick)="showFormPreviewerModal()"></app-buttons>

<p class="font-poppins font-normal">Texto con Poppins regular</p>

<p class="font-poppins font-semibold">Texto con Poppins semi-bold</p>

<p class="font-poppins font-bold">Texto con Poppins bold</p>

<searchable-dropdown
  [options]="searchableOptions"
  (valueChange)="onSelect($event)"
></searchable-dropdown>



<app-selector 
  label="Sector o industria" 
  [optionsInput]="['hola','hola2','hola3']"
  class="col-span-1">
</app-selector>

<div class="w-full flex justify-end">
  <multiselect
  [options]="multiselectOptions"
  (valueChange)="onSelect($event)"
  ></multiselect>
</div>

<app-checkbox></app-checkbox>

<div class="max-w-md mt-8">
  <input-date
    [control]="testForm.get('fechaNacimiento')!"
    label="Fecha de nacimiento"
  ></input-date>
</div>

 <div class="mt-12 mb-12">
  <app-table
  [showFilters]="false"
  [showSearch]="false"
  [data]="users"
  [showPagination]="true"
  [icon1]="'fi fi-rs-user'"
  [showSorting]="true"
   [filterOptions]="filterOptions"
  [filterLabels]="filterLabels"
  (iconAction1)="onEdit($event)"
  (iconAction2)="onDelete($event)"
  (toggleAction)="onToggle($event)"
  (searchChange)="onSearch($event)"
  (pageChange)="onPageChange($event)"
  (sortChange)="onSort($event)"
  [showToggle]="true"
  [columns]="columns"
  [isMocked]="true"
  >
  
</app-table>
 </div>

 <div class="p-6">
  <h2 class="text-xl font-semibold mb-4">Tabla simple</h2>

  <app-simple-table
    [columns]="columns"
    [paginatedData]="users"
    [showSorting]="true"
    [isFirstColumnDark]="true"
    (sortChange)="onSort($event)"
    (rowClick)="null"
  ></app-simple-table>
</div>

<div class="p-6">
  <h2 class="text-xl font-semibold mb-4">Vista previa</h2>
  <form-previewer></form-previewer>
</div>

        

<i class="fi fi-rs-user"></i>
<i class="fi fi-rs-settings"></i>
<i class="fi fi-rs-search"></i>
<i class="fi fi-ss-check-circle"></i>

<div class="w-[240px]">
  <upload-file 
    (fileSelected)="onFileSelected($event)" 
    [validFormatList]="uploadFileValidFormats"
    [maxFileSizeMB]="5"
  ></upload-file>
</div>
  </main>
</div>

<tabs>
  <tab label="Usuarios">
    <p>Aquí va el contenido de Usuarios</p>
  </tab>

  <tab label="Roles">
    <p>Gestión de roles de usuario</p>
  </tab>

  <tab label="Equipos">
    <p>Administración de equipos</p>
  </tab>
</tabs>



